import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  margin-left: 10px;
`;
